/* InstallDialogEditionHeader.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _16 = "._2hwxpxbi{margin-right:var(--ds-space-200,1pc)}";
const _15 = "._18u0pxbi{margin-left:var(--ds-space-200,1pc)}";
const _14 = "._4t3i1j6v{height:1rem}";
const _13 = "._bfhk7jlr{background-color:var(--ds-border-bold,#758195)}";
const _12 = "._1bsbt94y{width:1px}";
const _11 = "._19pku2gc{margin-top:var(--ds-space-100,8px)}";
const _10 = "._4cvr1h6o{align-items:center}";
const _9 = "._n3td1ejb{padding-bottom:var(--ds-space-300,24px)}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._n7zlpp12{border-bottom:var(--_18x9sjc)}";
const _6 = "._1yt41ejb{padding:var(--ds-space-300,24px)}";
const _5 = "._19itpp12{border:var(--_18x9sjc)}";
const _4 = "._2rko1j6v{border-radius:1rem}";
const _3 = "._4t3iqf5o{height:3.25rem}";
const _2 = "._1bsbqf5o{width:3.25rem}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isBugBountyParticipant } from '@atlassian/amkt-common';
import { useStatsig } from '@atlassian/mpac-feature-flags';
import { H5 } from '@atlassian/mpac-primitives';
import { AtlassianProductHostingType } from '@atlassian/mpac-types/graphql-gateway-types';
import React from 'react';
import { TEST_IDS } from '../../primitives/testIds';
import DarkModeLogoBackground from '../DarkModeLogoBackground';
import { HeaderPartnerDetails } from '../HeaderPartnerDetails';
import { InstallCount, useInstallMessage } from '../InstallCount';
import * as utils from './AppHeader.utils';
import { IconContainer, ItemValue, TrustSignalsItem } from './AppHeaderV2.styles';
import { getAppIcon } from './components/HeaderAppIcon';
import HeaderCertificationBadge from './components/HeaderCertificationBadge';
import HeaderRatings from './components/HeaderRatings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._otyridpf{margin-bottom:0}";
const AppName = forwardRef((_ref, __cmplr) => {
  let {
      as: C = H5,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_otyridpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AppName.displayName = 'AppName';
}
const appDetailsContainerStyles = null;
const iconContainerStyles = null;
const containerStyles = null;
const socialProofsStyles = null;
const socialProofsSeparatorStyles = null;
const HeaderAppIcon = props => {
  const {
    appKey,
    origin,
    appIconLink,
    icon
  } = props;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_1bsbqf5o _4t3iqf5o"]),
      children: /*#__PURE__*/_jsx(DarkModeLogoBackground, {
        children: getAppIcon(origin, appKey, icon, appIconLink)
      })
    })]
  });
};

// eslint-disable-next-line max-lines-per-function, complexity
function InstallDialogEditionHeader(_ref2) {
  var _appHeaderDetails$pro, _appHeaderDetails$pro2, _appHeaderDetails$com;
  let {
    appHeaderDetails,
    appIconLink,
    appRatingLink,
    headerInjection,
    isAppCloudFortified = false,
    openMarketplaceLinksInNewTab = true,
    bugBountyParticipant = null
  } = _ref2;
  const {
    enableRunsOnAtlassian
  } = useStatsig();
  const isRunsOnAtlassianApp = enableRunsOnAtlassian() && (((_appHeaderDetails$pro = appHeaderDetails.programs) === null || _appHeaderDetails$pro === void 0 ? void 0 : (_appHeaderDetails$pro2 = _appHeaderDetails$pro.runsOnAtlassian) === null || _appHeaderDetails$pro2 === void 0 ? void 0 : _appHeaderDetails$pro2.status) || false);
  const showNewAppMessage = utils.showNewAppMessage(appHeaderDetails);
  const showSecurityBadge = isAppCloudFortified || isBugBountyParticipant(AtlassianProductHostingType.Cloud, bugBountyParticipant) || isRunsOnAtlassianApp;
  const {
    tooltipMessage: installTooltipMessage,
    installCountMessage,
    showDownloadIcon,
    isLoading: isInstallMessageLoading
  } = useInstallMessage({
    distribution: appHeaderDetails.distribution,
    showNewAppMessage,
    compatibleProducts: (_appHeaderDetails$com = appHeaderDetails.compatibleProducts) !== null && _appHeaderDetails$com !== void 0 ? _appHeaderDetails$com : [],
    showAetherAppListingPage: true
  });
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6]
    }), /*#__PURE__*/_jsxs("div", {
      "data-testid": TEST_IDS.APP_HEADER,
      className: ax(["_2rko1j6v _19itpp12 _1yt41ejb"]),
      style: {
        "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
      },
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_7, _8, _9]
        }), /*#__PURE__*/_jsxs("div", {
          className: ax(["_n7zlpp12 _1e0c1txw _n3td1ejb"]),
          style: {
            "--_18x9sjc": ix("1px solid ".concat("var(--ds-border, #091E4224)"))
          },
          children: [/*#__PURE__*/_jsx(IconContainer, {
            "data-testid": TEST_IDS.APP_HEADER_ICON,
            children: /*#__PURE__*/_jsx(HeaderAppIcon, {
              origin: appHeaderDetails.origin,
              icon: appHeaderDetails.icon,
              appKey: appHeaderDetails.key,
              appIconLink: appIconLink
            })
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(AppName, {
              "data-testid": TEST_IDS.APP_HEADER_APP_NAME,
              children: appHeaderDetails.name
            }), /*#__PURE__*/_jsx(HeaderPartnerDetails, {
              showAetherAppListingPage: true,
              name: appHeaderDetails.partner.name,
              link: appHeaderDetails.partner.link,
              partnerTierType: appHeaderDetails.partner.partnerTierType
            }), /*#__PURE__*/_jsxs(CC, {
              children: [/*#__PURE__*/_jsx(CS, {
                children: [_8, _10, _11]
              }), /*#__PURE__*/_jsxs("div", {
                className: ax(["_1e0c1txw _4cvr1h6o _19pku2gc"]),
                children: [!showNewAppMessage && /*#__PURE__*/_jsx(TrustSignalsItem, {
                  "data-testid": TEST_IDS.APP_HEADER_RATINGS,
                  children: /*#__PURE__*/_jsx(ItemValue, {
                    children: /*#__PURE__*/_jsx(HeaderRatings, {
                      appKey: appHeaderDetails.key,
                      appRatingLink: appRatingLink,
                      openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
                      ratings: appHeaderDetails.ratings,
                      showAetherAppListingPage: true
                    })
                  })
                }), !!installCountMessage && /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_12, _13, _14, _15, _16]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_1bsbt94y _bfhk7jlr _4t3i1j6v _18u0pxbi _2hwxpxbi"])
                  })]
                }), !!installCountMessage && /*#__PURE__*/_jsx(TrustSignalsItem, {
                  "data-testid": TEST_IDS.APP_HEADER_INSTALL_COUNT,
                  role: "img",
                  "aria-label": installTooltipMessage || '',
                  children: /*#__PURE__*/_jsx(ItemValue, {
                    children: /*#__PURE__*/_jsx(InstallCount, {
                      showAetherAppListingPage: true,
                      tooltipMessage: installTooltipMessage,
                      installCountMessage: installCountMessage,
                      showDownloadIcon: showDownloadIcon,
                      isLoading: isInstallMessageLoading
                    })
                  })
                }), !!showSecurityBadge && /*#__PURE__*/_jsxs(CC, {
                  children: [/*#__PURE__*/_jsx(CS, {
                    children: [_12, _13, _14, _15, _16]
                  }), /*#__PURE__*/_jsx("div", {
                    className: ax(["_1bsbt94y _bfhk7jlr _4t3i1j6v _18u0pxbi _2hwxpxbi"])
                  })]
                }), showSecurityBadge && /*#__PURE__*/_jsx(TrustSignalsItem, {
                  "data-testid": TEST_IDS.APP_HEADER_CERTIFICATION,
                  children: /*#__PURE__*/_jsx(ItemValue, {
                    children: /*#__PURE__*/_jsx(HeaderCertificationBadge, {
                      isRunsOnAtlassianApp: isRunsOnAtlassianApp,
                      isAppCloudFortified: isAppCloudFortified,
                      bugBountyParticipant: bugBountyParticipant,
                      showAetherAppListingPage: true
                    })
                  })
                })]
              })]
            })]
          })]
        })]
      }), !!headerInjection && /*#__PURE__*/_jsx("div", {
        "data-testid": TEST_IDS.APP_HEADER_INJECTION,
        children: headerInjection
      })]
    })]
  });
}
export default InstallDialogEditionHeader;